import React from "react";
import { CustomerData } from "../types/bomTypes";
import CommonButtons from "../../../../../../shared/components/CommonButtons";

interface Props {
  customer: CustomerData | null;
  onAddProduct: () => void;
}

const CustomerInfo: React.FC<Props> = ({ customer, onAddProduct }) => {
  if (!customer) return null;

  const customerFields: { label: string; value: string | number | undefined }[] = [
    { label: "Customer name :", value: customer.firstName + (customer.middleName ? ` ${customer.middleName}` : "") + (customer.lastName ? ` ${customer.lastName}` : "") },
    { label: "Phone number :", value: customer.phones[0]?.phone },
  ];

  return (
    <div className="w-full flex justify-between items-start gap-4 px-0.5">
      <div className="flex flex-col gap-1 px-0.5">
        {customerFields.map((field, index) => (
          <div key={index} className="flex gap-2">
            <p className="font-medium">{field.label}</p>
            <p>{field.value}</p>
          </div>
        ))}
      </div>
      <div>
        <CommonButtons className="w-36" label="Add Product" onClick={onAddProduct} />
      </div>
    </div>
  );
};

export default CustomerInfo;
